var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.5%",
    y: "-7.5%",
    width: "115.0%",
    height: "115.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.148546766 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[Tablet][Portrait]01-MyClients-planningList-actions-advanceSearch",
    transform: "translate(-707.000000, -78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(307.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(402.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.2000887,13 L28.2809597,13.0072499 C28.4908404,13.0453512 28.65,13.2290824 28.65,13.4500334 C28.65,15.1406709 27.9252029,16.7547628 26.6616292,17.8779526 L26.6616292,17.8779526 L23.9244254,20.3109412 L23.7902584,20.4398656 C23.3614624,20.8851982 23.1188208,21.4821841 23.1188208,22.1050366 L23.1188208,22.1050366 L23.1188208,25.7417055 L23.1099971,25.830392 C23.0867357,25.9460486 23.0185625,26.0493308 22.9183659,26.1161754 L22.9183659,26.1161754 L19.2308416,28.5744029 L19.160375,28.6131152 C18.8730556,28.7395606 18.5313013,28.5310623 18.5313013,28.2000887 L18.5313013,28.2000887 L18.5313013,22.1050366 L18.5240785,21.9190826 C18.4761151,21.3026613 18.1911589,20.7246854 17.7256989,20.3109432 L17.7256989,20.3109432 L14.988365,17.8779474 L14.7827909,17.6862756 C13.6465011,16.575183 13,15.0467466 13,13.4500334 C13,13.2014499 13.2014499,13 13.4500334,13 L13.4500334,13 L28.2000887,13 Z M27.7337978,13.8999447 L13.9162022,13.8999447 L13.94194,14.0975476 L13.9818728,14.3527148 C14.1829279,15.4516569 14.745983,16.4581459 15.5863167,17.2052781 L15.5863167,17.2052781 L18.3235403,19.6382844 L18.4806102,19.7874451 C19.0871999,20.4026568 19.4312459,21.2356536 19.4312459,22.1050366 L19.4312459,22.1050366 L19.4312459,27.3591656 L22.1408249,25.5528249 L22.2187541,25.4072149 L22.2187541,22.1049145 L22.2258747,21.8884547 C22.2826512,21.0264802 22.6766902,20.2159286 23.3264699,19.6382753 L23.3264699,19.6382753 L26.0636697,17.2051681 L26.2526379,17.0282673 C27.049833,16.2423938 27.5631817,15.2098541 27.70806,14.0975476 L27.70806,14.0975476 L27.7337978,13.8999447 Z",
    id: "Combined-Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFilter);
export default __webpack_public_path__ + "static/media/btn-filter.fc847af711b181fab3662f4bf2337a8e.svg";
export { ForwardRef as ReactComponent };